// Putting this back because there is dependency in CSX on @woolworthsnz/onecard which has dependency of this
// This can only be removed after removing @woolworthsnz/onecard dependenct in CSX
export enum OnecardErrorState {
	noCard = 'noCard',
	mismatchedDetails = 'mismatchedDetails',
}
